<div class="section3">
    <div class="buttonsSection3 primaryDefault">
            <app-button
                class="cosentino-button we M fill-available positionButton"
                [secondary]="true"
                size="small"
                (onClick)="onClick()"
                [gtmLabel]="'button_back-to-my-galleries'"
                gtm-usertype="ad"
                data-id="buttonId"
                *ngIf="!creating"
                (click)="goBack()"
            >
                <span class="typography-body-m-medium oneLine">
                    {{ 'my_galleries.modal_new_gallery_modal_confirm_back' | translate }}
                </span>
            </app-button>
            <app-button
                class="w-full md:w-auto"
                [skin]="'we'"
                [primary]="true"
                [size]="'medium'"
                (onClick)="onClick()"
                [disabled]="!isFormValid"
                gtm-label="mis_galerias_nueva"
                gtm-usertype="ad"
                data-id="buttonId"
            >
                <span class="">
                    {{ 'new-galleries.button-publish-gal' | translate }}
                </span>
            </app-button>
    </div>
</div>
